export default {"src":"/_next/static/media/industry_resource.88f4aa03.svg","height":215,"width":289,"blurWidth":0,"blurHeight":0};